import { getSDKConfig } from '../shares/lib/getSDKConfig';
import { SwipeGamesItem } from '../shares/model/swipe';
import swipeSdkStyles from '../../../public/assets/css/swipe-styles.css?inline';

export const createSwipeControlStyle = async (): Promise<void> => {
  const swipeSDKConfig = getSDKConfig();

  const styleElement = document.createElement('style');
  let cssContent = ``;

  if (swipeSDKConfig?.swipeGames?.styles) {
    cssContent += `.swipe-ctr .swipe-control {\n`;
    if (
      swipeSDKConfig.swipeGames.styles.iconBgColor &&
      swipeSDKConfig.swipeGames.styles.iconBgColor !== '#000'
    ) {
      cssContent += `background: ${swipeSDKConfig.swipeGames.styles.iconBgColor};\n`;
    }
    cssContent += ` top: ${swipeSDKConfig.swipeGames.styles.iconTop ?? 0}%;\n`;
    cssContent += ` }\n`;
  }

  cssContent += `.swipe-ctr .swipe-control__item.sports {
        background-image: url(${swipeSDKConfig?.swipeGames?.homeIconUrl ?? ''});
    }\n`;

  swipeSDKConfig?.swipeGames?.gameListConfig.gameList?.forEach(
    (game: SwipeGamesItem) => {
      cssContent += `.swipe-ctr .swipe-control__item.game_icon_${game?.gameId} {
            background-image: url(${game?.gameIconUrl});
            border-radius: 50%;
            background-size: cover;
            background-repeat: no-repeat;
        }\n`;
    },
  );

  styleElement.appendChild(document.createTextNode(swipeSdkStyles));

  styleElement.appendChild(document.createTextNode(cssContent));

  document.head.appendChild(styleElement);
};
